import * as React from 'react';
import PortalIntegration from '../PortalIntegration';
import * as FunctionFile from '../FunctionFile';

class OtherLinksProps {
    username: string;
}

export default class OtherLinks extends React.Component<OtherLinksProps, undefined> {

    render() {

        return <div className="OtherLinks">
            <div className="tiles">
                {this.button(
                    PortalIntegration.makeRequireLoginUrl(this.props.username, '/Compose'), 
                    'Compose', 
                    'ms-Icon ms-Icon--Handwriting',
                    (event) => { 
                        event.preventDefault();
                        FunctionFile.showComposeDialog(this.props.username, null);
                    })}
                {this.button(PortalIntegration.makeRequireLoginUrl(this.props.username, '/Inbox'), 'Inbox', 'ms-Icon ms-Icon--InboxCheck')}
                {this.button(PortalIntegration.makeRequireLoginUrl(this.props.username, '/Sent'), 'Sent', 'ms-Icon ms-Icon--Send')}
                {this.button(PortalIntegration.makeRequireLoginUrl(this.props.username, '/Dashboard'), 'Dashboard', 'ms-Icon ms-Icon--Settings')}
                {this.button(PortalIntegration.makeRequireLoginUrl(this.props.username, '/Invite'), 'Invite', 'ms-Icon ms-Icon--ChatInviteFriend')}
                {this.button(PortalIntegration.makeRequireLoginUrl(this.props.username, '/User/Profile/' + encodeURI(this.props.username)), 'My Account', 'ms-Icon ms-Icon--ContactCard')}
            </div>

        </div>;
    }

    private button(url: string, label: string, iconClass: string, clickHandler?: (e: any) => void): JSX.Element {

        return <a className="ms-Button ms-Button--secondary" href={url} target="_blank" onClick={clickHandler}>
            <div className="ms-Button-flexContainer">
                <i className={iconClass} aria-hidden="true"></i>
                <span className="ms-Button-label">{label}</span>
            </div>
        </a>;
    }

}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/components/OtherLinks.tsx